import { useState } from 'react';
import AccountUpdated from './your.account.is.updated';
import UpdateAccountSection from './update.account.section';

interface UpdateLoginProps {
  username: string
  password: string
  showUsername: boolean
  showPassword: boolean
  showSecretQuestion: boolean
  showEmail: boolean
  backToLogin: () => void
}

const UpdateLogin = (props: UpdateLoginProps) => {
    const [page, setPage] = useState(0);
    const {username, password, showUsername, showPassword, showSecretQuestion, showEmail, backToLogin} = props;

    const updateAccount =
      <UpdateAccountSection
          emailVisible={showEmail}
          passwordVisible={showPassword}
          resetLoginFlow={backToLogin}
          secretQuestionVisible={showSecretQuestion}
          showPageCallBack={(code: number) => setPage(code)}
          temporaryPassword={password}
          temporaryUsername={username}
          usernameVisible={showUsername}
      />;

    const accountUpdatedInfoSection =
      <AccountUpdated resetLoginFlow={backToLogin}/>;

    const pages = [updateAccount, accountUpdatedInfoSection];

    return pages[page];
};
export default UpdateLogin;